'use client';

import Container from '@/components/ui/container';
import { cn, parseHeading, sanitizeHtml } from '@/lib/utils';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FaqItem {
	title: string;
	content: string;
}

interface FaqProps {
	data: {
		title?: string;
		headline?: string;
		description?: string;
		faqs?: FaqItem[];
	};
	blockId?: string;
	itemId?: string;
}

const Faq = ({ data, blockId, itemId }: FaqProps) => {
	const { title, headline, description, faqs } = data;

	return (
		<section className="py-16 md:py-24 bg-white" data-directus-id={itemId}>
			<Container className="max-w-4xl">
				<div className="text-center mb-12">
					{title && (
						<span
							className="text-orange font-bold uppercase tracking-wider mb-3 block"
							data-vercel-edit-target={`block_faq:${itemId}:title`}
						>
							{title}
						</span>
					)}
					{headline && (
						<h2
							className="text-3xl md:text-4xl font-heading text-blue-dark mb-6"
							data-vercel-edit-target={`block_faq:${itemId}:headline`}
						>
							{parseHeading(headline)}
						</h2>
					)}
					{description && (
						<div
							className="text-gray-dark leading-relaxed prose max-w-2xl mx-auto"
							data-vercel-edit-target={`block_faq:${itemId}:description`}
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
						/>
					)}
				</div>

				{faqs && faqs.length > 0 && (
					<Accordion type="single" collapsible className="w-full">
						{faqs.map((faq, index) => (
							<AccordionItem key={index} value={`item-${index}`}>
								<AccordionTrigger className="text-lg font-heading font-bold text-blue-dark text-left">
									{faq.title}
								</AccordionTrigger>
								<AccordionContent>
									<div className="prose max-w-none text-gray-dark" dangerouslySetInnerHTML={{ __html: sanitizeHtml(faq.content) }} />
								</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				)}
			</Container>
		</section>
	);
};

export default Faq;
